// extracted by mini-css-extract-plugin
export default {"button":"ShapeButton_button__PhgRW","circle":"ShapeButton_circle__ZLzsG"};